// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper__11G0_","keyWrapper":"Button_keyWrapper__2tngk","keyName":"Button_keyName__FiF3w"};